'use client';

import { PageMain } from '@/app/(app)/page-main';
import { CreateSkillDialog } from '@/app/(app)/settings/skills/dialog';
import { SkillsTable } from '@/app/(app)/settings/skills/table/table';

export function SkillsPage() {
  return (
    <PageMain title='Skills'>
      <div className='flex w-full items-center justify-between'>
        <div className='flex flex-col gap-0.5'>
          <h1 className='text-heading-lg'>Skills</h1>
          <p className='text-sm text-muted-foreground'>Manage skills available for your services.</p>
        </div>
        <CreateSkillDialog />
      </div>
      <SkillsTable />
    </PageMain>
  );
}
